<section class="reviews" [ngClass]="{'reviews-with-character': isShowCharacter}" >
  @if (isShowCharacter) {
    <img class="reviews-char-img" src="/assets/img/website/character.svg" alt="Character image">
  }

  <div class="website-container website-container-transparent">
    <div class="heading-row">
      <h5 class="reviews-heading">{{ 'WEBSITE.REVIEWS.TITLE' | translate }}</h5>

      <div class="review-controls">
        <button class="reviews-control" (click)="goPrev()">
          <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
            <circle cx="20" cy="20" r="19.15" transform="rotate(180 20 20)" fill="#252525" stroke="#F9F7F5" stroke-width="1.7"/>
            <path d="M19.5157 27.9723L17.8917 29.5542L8.40797 20.1274L17.8917 10.7007L19.5157 12.2826L12.7601 18.9975L31.3379 18.9975L31.3379 21.2573L12.7601 21.2574L19.5157 27.9723Z" fill="#F9F7F5"/>
          </svg>
        </button>

        <button class="reviews-control" (click)="goNext()">
          <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
            <circle cx="20" cy="20" r="19.15" fill="#252525" stroke="#F9F7F5" stroke-width="1.7"/>
            <path d="M20.4843 12.0277L22.1083 10.4458L31.592 19.8726L22.1083 29.2993L20.4843 27.7174L27.2399 21.0025L8.66212 21.0025L8.66212 18.7427L27.2399 18.7427L20.4843 12.0277Z" fill="#F9F7F5"/>
          </svg>
        </button>
      </div>
    </div>

    <swiper-container #swiperContainer init="false">
      @for (review of reviews; track review.imageSrc) {
        <swiper-slide class="swiper-slide">
          <app-review
            class="review-wrapper"
            [config]="review"
          />
        </swiper-slide>
      }
    </swiper-container>
  </div>
</section>
